import { mergeMap, map } from 'rxjs/operators';
import { ofType } from 'redux-observable';

import { FETCH_RESINS } from '../actions/action-types';
import { fetchResinsFullfilled } from '../actions';
import { getResins } from '../services/resins';

export function fetchResinsEpic(action$){
  return action$
    .pipe(
      ofType(FETCH_RESINS),
      mergeMap(action =>
        getResins(action.payload).pipe(
          map(resins => fetchResinsFullfilled(resins))
        )
      )
    );
}

export default fetchResinsEpic;



// WEBPACK FOOTER //
// ./src/epics/fetchResins.js